@if (form(); as form) {
  <ui-multi-step-form
    [data]="form"
    [hideTitle]="true"
    [control]="formControl"
    [submitHandler]="stepSubmitHandler"
    (stepBack)="onStepBack($event)"
  ></ui-multi-step-form>
}
